import Axios from 'axios';
import { useUserStore } from '@/stores/UserStore'
import { useAppStore } from '@/stores/AppStore'
import { QueryParams } from '@/stores/common/query_params'
import { debounce } from 'lodash';

const query_params = new QueryParams()

const axios = Axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    timeout: 10000,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
    },
})

let queryRunning = 0

// Type augmentation pour permettre `skipLoader: true` sur une requete
// (utile pour le polling qui ne doit pas declencher le loader global).
declare module 'axios' {
    interface AxiosRequestConfig {
        skipLoader?: boolean
    }
}

// Global loader.
axios.interceptors.request.use((config) => {
        if ((config as any).skipLoader) return config
        const appStore = useAppStore()
        queryRunning += 1
        appStore.isLoading = true
        return config
    }
);

const stopLoader = debounce(() => {
    const appStore = useAppStore()
    if (queryRunning <= 0) {
        appStore.isLoading = false
        queryRunning = 0
    }
}, 650)

// Loader stop.
axios.interceptors.response.use((response) => {
        if ((response.config as any)?.skipLoader) return response
        queryRunning -= 1
        if (queryRunning <= 0) {
            stopLoader()
        }
        return response
    }, (error) => {
        if ((error.config as any)?.skipLoader) return Promise.reject(error)
        queryRunning -= 1
        if (queryRunning <= 0) {
            stopLoader()
        }
        return Promise.reject(error);
    }
);

// Query params.
axios.interceptors.request.use(
    async function (config) {
        if (config.params) {
            config.params = query_params.translate(config.params)
        }
        return config
    },
    function (error) {
        return Promise.reject(error);
    },
);

// Access Token
axios.interceptors.request.use(
    async function (config) {
        const userStore = useUserStore()
        if (!config.headers) return config;
        if (userStore.accessToken) {
            config.headers['Authorization'] = `Bearer ${userStore.accessToken}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    },
);

/**
 * TODO :
 * - Traiter et formatter les erreurs API
 * - Auto refresh token
 */

export default axios;